import { Colours } from '../../../../base-styles/colours';
import { SectorColours } from '../../../../base-styles/sector-colours';
import { holdsActiveCustomModel } from '../../../../functions/client-model/client-node/holds-active-custom-model';
import { holdsCustomModel } from '../../../../functions/client-model/client-node/holds-custom-model';
import { holdsInitialisedUtilisationTE } from '../../../../functions/client-model/client-node/holds-initialised-utilisation-te';
import { isLeafNode } from '../../../../functions/client-model/client-node/is-leaf-node';
import { isNodeAchievable } from '../../../../functions/is-node-achievable';
import { transitionElementToSector } from '../../../../functions/transition-target-to-sector';
import { stringToSector } from '../../../../functions/transition-targets/string-to-sector';
import { ClientNode } from '../../../../model/client-model/client-node';
import { Sector } from '../../../../model/sector';
import { groupColourToSector } from '../../../../modules/diagram/components/tree-diagram/group-color-to-sector';
import { getChildren } from '../../../../public/dashboard/shared/functions/get-children';
import { ClientBoardContainer } from '../../../../public/dashboard/shared/model/client-board-container';
import { DashboardColours } from '../../../../public/dashboard/shared/model/dashboard-colours';
import { TransitionTargetSector } from '../../../editor-targets-list/components/board-targets/sectors';
import { sectorToDashboardColour } from '../../functions/sector-to-dashboard-colour';

export function colourForNodeV41(board: ClientBoardContainer, node: ClientNode): DashboardColours {
  if (node.nodeProperties.groupColour) {
    const sector = groupColourToSector(Sector.None, node.nodeProperties.groupColour);
    return sectorToDashboardColour(sector);
  }

  if (!isNodeAchievable(node)) {
    return {
      main: Colours.notAchievableNow,
      dark: Colours.notAchievableNowDark,
      light: Colours.notAchievableNow,
    };
  }

  if (isLeafNode(node)) {
    return _colourForLeafNode(node);
  }

  let colours: DashboardColours[] = getChildren(board, node).reduce((childColours: DashboardColours[], childNode) => {
    const considerNode =
      !isLeafNode(childNode) || holdsInitialisedUtilisationTE(childNode) || holdsActiveCustomModel(childNode);
    const considerColour = isNodeAchievable(childNode) && considerNode;
    if (considerColour) {
      childColours.push(colourForNodeV41(board, childNode));
    }
    return childColours;
  }, []);

  if (colours.length) {
    const firstColour = colours[0];
    const firstMainColour = firstColour.main;
    const mainColours = colours.map((c) => c.main);
    return mainColours.every((s) => s === firstMainColour) ? firstColour : _colourForUnknownNode();
  }
  return _colourForUnknownNode();
}

function _colourForUnknownNode(): DashboardColours {
  return {
    main: SectorColours.unknownColour,
    dark: Colours.unknownColourDark,
    light: Colours.unknownColourLight,
  };
}
function _colourForLeafNode(node: ClientNode): DashboardColours {
  let sector: Sector | undefined;
  if (holdsCustomModel(node)) {
    sector = stringToSector(
      node.nodeProperties.customTargetModelData
        ? node.nodeProperties.customTargetModelData.sector
        : TransitionTargetSector.TRANSPORT
    );
  } else if (holdsInitialisedUtilisationTE(node)) {
    sector = transitionElementToSector(node.nodeProperties.transitionElement);
  }
  if (sector !== undefined) {
    return sectorToDashboardColour(sector);
  }
  return _colourForUnknownNode();
}
